import { Injectable } from '@angular/core';
import { AutomaticUpdatesDataService } from '../data-services/automatic-updates-data.service';

@Injectable({ providedIn: 'root' })
export class AutomaticUpdatesService {

    constructor(
        private automaticUpdatesDataService: AutomaticUpdatesDataService
    ) { }

    GetList(model: any): Promise<any> {
        return this.automaticUpdatesDataService.GetList(model);
    }
    Update(model: any): Promise<any> {
        return this.automaticUpdatesDataService.Update(model);
    }
}